import React from 'react'
import colors from '../../../../theme/colors'

export default () => (
  <div style={styles.container} />
)

const styles = {
  container: {
    height: 0,
    width: 0,
    borderTop: '25px solid transparent',
    borderBottom: '25px solid transparent',
    borderLeft: `25px solid ${colors.green}`,
  },
}
